// Export the function
export function header_height_property() {
	setTimeout(function() {
		let header_height = $('.l-header').outerHeight() > 120 ? 120 : $('.l-header').outerHeight();
		document.documentElement.style.setProperty('--header-height', header_height + 'px');
	}, 500);
}

(function ($) {
	'use strict';

	$(document).on('ready', function() {
		initialize_header();
		detect_mobile();
		header_height_property();
	});

	$(window).on({
		'scroll touchmove': function() {
			header_sticky();
		},
		'resize': function() {
			detect_mobile();
			header_height_property();
			reset_header();
		},
	});

	const $body = $('body');
	const $toggable = $('.header__toggable');
	const $openMenuToggle = $('.header__inner > .main-menu__toggle');
	const $closeMenuToggle = $('.header__toggable .main-menu__toggle');
	const $mobileMenuToggle = $('.main-menu__toggle');

	// This function detects whether the user is on a mobile device or using a resized window.
	// It does so by checking two conditions:
	// 1. Whether the mobile menu toggle element is visible (implying a mobile-sized viewport).
	// 2. Whether the browser's user agent string indicates a mobile device (e.g., Android or any 'Mobi' devices).
	function detect_mobile() {
		// Check if the viewport is of mobile size
		const isDesktop = $mobileMenuToggle.css('display') == 'none';
		// Simple check for mobile user agent
		let isMobileUserAgent = /Mobi|Android/i.test(navigator.userAgent);

		if (!isDesktop && isMobileUserAgent) {
			$body.addClass('is-mobile mobile-device');
		} else if (isMobileUserAgent) {
			$body.addClass('mobile-device');
		} else if (!isDesktop) {
			$body.addClass('is-mobile');
		} else {
			$body.removeClass('is-mobile mobile-device');
		}
	}

	function initialize_header() {
		$openMenuToggle.on('click', function() {
			$toggable.show();

			setTimeout(function() {
				$body.addClass('menu-is-open')
					.attr('draggable', false);
			}, 100);
		});

		$closeMenuToggle.on('click', function() {
			$body.removeClass('menu-is-open')
          .attr('draggable', true);

        setTimeout(function() {
          $toggable.hide();
					$('.header__navigation--utility.mobile .search-toggle.active').trigger('click');
        }, 100);
		});
	}

	function header_sticky() {
		var target = $(window).scrollTop();

		if (target > 0) {
			$body.addClass('header-is-fixed');
		} else {
			$body.removeClass('header-is-fixed');
		}
	}


	// Reset header on resize
	function reset_header() {
		//desktop
		if ( $openMenuToggle.css('display') === 'none' ) {
			$body
				.removeClass('menu-is-open')
				.attr('draggable', false);

			$toggable.show();

			$('.l-header .accordion-basic--group').each(function() {
				$(this).find('.main-menu--expandable').show();
			});

			$('.header__navigation--utility.mobile .utility-toggle.active').each(function() {
				$(this).trigger('click');
			});

			$('.header__navigation--utility.mobile .search-toggle.active').trigger('click');
		}
		// mobile
		else {
			if ( !$('.menu-is-open').length ) {
				$body.removeClass('menu-is-open');
				$toggable.hide();

				$('.l-header .accordion-basic--group').each(function() {
					$(this)
						.removeClass('active')
						.attr('aria-expanded', false);

					$(this).find('.main-menu--expandable').hide();
				});

				$('.header__navigation--utility.desktop .search-toggle.active').trigger('click');
			}
		}
	}
})(jQuery);
